import $ from 'jquery';

const CLASS = {
    IS_OPEN: 'is-open',
    BURGER_CONTENT: '.js-burger-content'
}

export default class BurgerBtn {
    constructor(selectorBurger, selectorBurgerContent, selectorCloseBtn = null) {
        var _self = this;

        // Burger Btn is used to open / close element
        // by himself if no selector to close
        if (!selectorCloseBtn) {
            _self.isToggleBtn = true;
        } else {
            _self.isToggleBtn = false;
            _self.$btnClose = $(selectorCloseBtn);
        }

        // get Btn Element
        _self.$burgerBtn = $(selectorBurger);

        // get related Menu
        _self.$containerBurgerContent = $(selectorBurgerContent);

        // initial state
        _self.isOpen = false;

        // burger content
        _self.$burgerContent = $(CLASS.BURGER_CONTENT);

        _self.$document = $(document);
    }

    /**
     * Init App
     */
    init() {
        var _self = this;
        _self.bindEvents();
    }

    /**
     * Bind required events
     */
    bindEvents() {
        var _self = this;
        if (_self.isToggleBtn) {
            _self.$burgerBtn.bind("click", function (e) {
                if(_self.isOpen) {
                    _self.closeMenu();
                } else {
                    _self.openMenu();
                }
                e.stopPropagation();
            });
        }
        else {
            // bind btn burger
            _self.$burgerBtn.bind("click", function (e) {
                _self.openMenu();
                e.stopPropagation();
            });
            // bind btn close
            _self.$btnClose.bind("click", function (e) {
                _self.closeMenu();
                e.stopPropagation();
            });
        }

        _self.$burgerContent.bind("click", function (e) {
            e.stopPropagation();
        });

        // bind close menu clicking everywhere
        _self.$document.bind("click", function () {
            if(_self.isOpen) {
                _self.closeMenu();
            }
        });
    }

    /**
     * Open Mobile Menu
     */
    openMenu() {
        this.$containerBurgerContent.addClass(CLASS.IS_OPEN);
        this.$burgerBtn.attr("aria-expanded","true");
        this.isOpen = true;
    }

    /**
     * Close Mobile Menu
     */
    closeMenu() {
        this.$containerBurgerContent.removeClass(CLASS.IS_OPEN);
        this.$burgerBtn.attr("aria-expanded","false");
        this.isOpen = false;
    }
}


// WEBPACK FOOTER //
// ./src/components/header/lhs/transverse/burgerBtn.js